import { ActionTypes } from '../actions/cardProjectActions';

const initialState = {
  busy: false,
  selectedGuestIds: [],
};

const recipients = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_PROJECT_GUEST_IDS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_PROJECT_GUEST_IDS: {
      const { projectGuestIds } = action.payload;
      return { ...state, busy: false, selectedGuestIds: projectGuestIds };
    }
    case ActionTypes.RESET_SELECTED_GUEST_IDS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default recipients;



// WEBPACK FOOTER //
// ./src/cards/reducers/recipients.js